import './footer.scss'

const selectors = {
  scrollButton: '[data-footer-scroll-button]',

  footer: '[data-footer]',
  groupItem: '[data-footer-group]',
  groupHeader: '[data-footer-group-header]',
  groupBody: '[data-footer-group-body]',
  active: 'active',
}

const handleClick = (active, groups) => {
  if (!window.matchMedia('(max-width: 767px)').matches) return

  groups.forEach((group) => {
    const isActive = active.group.classList.contains(selectors.active)

    group.group.classList.remove(selectors.active)
    group.body.style.height = '0px'

    if (isActive) return

    if (group.group.isSameNode(active.group)) {
      group.group.classList.add(selectors.active)
      group.body.style.height = group.body.firstElementChild.clientHeight + 'px'
    }
  })
}

const initFooterAccordion = (footer) => {
  let groups = footer?.querySelectorAll(selectors.groupItem)

  if (!groups) return

  groups = Array(...groups).map((group) => {
    const header = group.querySelector(selectors.groupHeader)
    const body = group.querySelector(selectors.groupBody)

    return {
      group,
      header,
      body,
    }
  })

  groups?.forEach((group) => {
    group.header.addEventListener('click', () => handleClick(group, groups))
  })
}

const initScrollButton = (footer) => {
  const scrollButton = footer.querySelector(selectors.scrollButton)

  scrollButton.addEventListener('click', () => window.scrollTo(0, 0))

  document.addEventListener('scroll', () => {
    const isFixed = scrollButton.classList.contains(selectors.active)
    const isFooterVisible = footer.getBoundingClientRect().top < window.innerHeight

    if (window.scrollY > window.innerHeight && !isFixed && !isFooterVisible) {
      const right = (window.innerWidth - 1192) / 2 - scrollButton.getBoundingClientRect().width

      scrollButton.classList.add(selectors.active)
      scrollButton.style.right = right >= 32 ? right + 'px' : '1%'
    }

    if ((window.scrollY < window.innerHeight && isFixed) || (isFooterVisible && isFixed)) {
      scrollButton.classList.remove(selectors.active)
    }
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  const footer = document.querySelector(selectors.footer)

  if (!footer) return

  initFooterAccordion(footer)
  initScrollButton(footer)
})
